import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import { usePublicApiService } from "contexts/PublicApiServiceProvider";

export const spendInsightsThreadsKeys = {
  allThreads: ["spendInsightsThreads"],
  threadsForCompany: ({ companyId }: { companyId: string }) => [
    ...spendInsightsThreadsKeys.allThreads,
    { companyId },
  ],
};

export const useGetThreads = ({ companyId }: { companyId: string }) => {
  const publicApi = usePublicApiService();
  return useQuery({
    queryKey: spendInsightsThreadsKeys.threadsForCompany({ companyId }),
    staleTime: 60 * 60_000,
    queryFn: () =>
      publicApi.getThreadsForCompany({ companyId }, { pageNumber: 1 }),
  });
};

export const useGetThreadsInfinite = ({ companyId }: { companyId: string }) => {
  const publicApi = usePublicApiService();
  return useInfiniteQuery({
    queryKey: spendInsightsThreadsKeys.threadsForCompany({ companyId }),
    queryFn: ({ pageParam = 1 }) =>
      publicApi.getThreadsForCompany(
        { companyId },
        { pageNumber: pageParam, pageSize: 20 }
      ),
    initialPageParam: 1,
    getNextPageParam: (lastPage) =>
      lastPage.pageSize * lastPage.pageNumber < lastPage.totalResults
        ? lastPage.pageNumber + 1
        : undefined,
    getPreviousPageParam: (firstPage) => firstPage.pageNumber - 1,
  });
};
